module.exports = __webpack_public_path__ + "media/images/area/feature/prefecture/gunma_excellence/021-19b870e574ab52c9fab94753eb47957e.jpg";